import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectWorkingProjectDescription } from '@/store/slices/project/selectors';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import EditDescription from '../edit-description/edit-description';

const EditProjectDescription = () => {
  const dispatch = useAppDispatch();
  const description = useAppSelector(selectWorkingProjectDescription);

  const onBlur = (value: string) => {
    dispatch(saveWorkingProjectByFields({ event_description: value }));
  };

  return <EditDescription onBlur={onBlur} defaultValue={description} maxRowsFocused={3} />;
};

export default EditProjectDescription;
